type Mood='haunting'|'boss'|'travel'|'temple';
class WorldMusic{
 private context:AudioContext|null=null;
 private loading:Promise<void>|null=null;
 private tracks=new Map<Mood,GainNode>();
 private mood:Mood='haunting';
 private enabled=true;
 private volume=1;
 setVolume(volume:number):void{this.volume=Math.max(0,Math.min(1,volume));this.mix();}
 setMood(mood:Mood):void{if(mood!==this.mood){this.mood=mood;this.mix();}document.body.dataset.musicMood=mood;}
 unlock():void{
  this.context??=new AudioContext();if(!document.hidden)void this.context.resume().catch(()=>undefined);
  this.loading??=Promise.all((['haunting','boss','travel','temple'] as Mood[]).map(async mood=>{
   const response=await fetch('/assets/audio/'+(mood==='travel'||mood==='temple'?'open-v001/':'r17/')+mood+'.wav');if(!response.ok)throw Error('BGM unavailable');
   const buffer=await this.context!.decodeAudioData(await response.arrayBuffer());
   const source=this.context!.createBufferSource(),gain=this.context!.createGain();source.buffer=buffer;source.loop=true;gain.gain.value=0;
   source.connect(gain);gain.connect(this.context!.destination);this.tracks.set(mood,gain);source.start();
  })).then(()=>{document.body.dataset.musicReady='true';this.mix();}).catch(()=>{document.body.dataset.musicReady='false';});
 }
 mount():void{
  document.getElementById('music-toggle')?.remove();
  const button=document.createElement('button');button.id='music-toggle';button.type='button';
  button.style.cssText='position:fixed;right:12px;top:50%;z-index:45;color:#e9dbb9;background:#101b20e8;border:1px solid #80714b;border-radius:8px;padding:8px;font:12px system-ui;';
  const label=()=>{button.textContent=this.enabled?'♫ BGM เปิด':'♫ BGM ปิด';button.setAttribute('aria-label',this.enabled?'ปิดเพลงประกอบ':'เปิดเพลงประกอบ');button.setAttribute('aria-pressed',String(this.enabled));};
  button.onclick=()=>{this.enabled=!this.enabled;this.unlock();this.mix();label();};label();document.body.append(button);
 }
 visibility():void{if(!this.context)return;if(document.hidden)void this.context.suspend();else void this.context.resume().catch(()=>undefined);}
 private mix():void{if(!this.context)return;for(const [mood,gain] of this.tracks){gain.gain.cancelScheduledValues(this.context.currentTime);gain.gain.setTargetAtTime(this.enabled&&mood===this.mood ? 0.38*this.volume : 0,this.context.currentTime,.45);}document.body.dataset.musicEnabled=String(this.enabled);}
}
export const worldMusic=new WorldMusic();
if(typeof window!=='undefined'){
 window.addEventListener('pointerdown',()=>worldMusic.unlock(),{once:true});window.addEventListener('keydown',()=>worldMusic.unlock(),{once:true});
 document.addEventListener('visibilitychange',()=>worldMusic.visibility());
}
